var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 23C16.1323 23 16.2594 22.9473 16.3532 22.8536C16.447 22.7598 16.4997 22.6326 16.4997 22.5V10.707L19.6457 13.854C19.7395 13.9479 19.8669 14.0006 19.9997 14.0006C20.1324 14.0006 20.2598 13.9479 20.3537 13.854C20.4475 13.7601 20.5003 13.6328 20.5003 13.5C20.5003 13.3672 20.4475 13.2399 20.3537 13.146L16.3537 9.146C16.3072 9.09944 16.252 9.06249 16.1913 9.03729C16.1305 9.01208 16.0654 8.99911 15.9997 8.99911C15.9339 8.99911 15.8688 9.01208 15.808 9.03729C15.7473 9.06249 15.6921 9.09944 15.6457 9.146L11.6457 13.146C11.5518 13.2399 11.499 13.3672 11.499 13.5C11.499 13.6328 11.5518 13.7601 11.6457 13.854C11.7395 13.9479 11.8669 14.0006 11.9997 14.0006C12.1324 14.0006 12.2598 13.9479 12.3537 13.854L15.4997 10.707V22.5C15.4997 22.6326 15.5523 22.7598 15.6461 22.8536C15.7399 22.9473 15.867 23 15.9997 23Z",
    fill: "#00948B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    stroke: "#00948B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterArrowUpIcon);
export default __webpack_public_path__ + "static/media/filter-arrow-up-icon.bd3119fc0d9eab4b4e6f8b10eb2b804e.svg";
export { ForwardRef as ReactComponent };